export const classifications = ["standstill", "fault", "slightImpairment", "generalInquiry"];
//# sourceMappingURL=classifications.js.map
